import React, { useState } from 'react';
import { Loader2, LockKeyhole, ShieldCheck } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { DobInput } from '@/components/myPay/DobInput';

const Label = ({ children, htmlFor }) => <label htmlFor={htmlFor} className="block text-sm font-semibold text-[#1A1F2E] mb-1.5">{children}</label>;

/** Staff ID + date of birth sign-in (no WMS account needed). */
export const LoginCard = ({ t, sites, site, setSite, onLogin, busy, error, initial = {} }) => {
  const [sid, setSid] = useState(initial.sid || '');
  const [dob, setDob] = useState(initial.dob || '');
  const ready = sid.trim() && dob.length === 10 && !busy;
  const submit = (e) => { e.preventDefault(); if (ready) onLogin(sid.trim(), dob); };
  return (
    <form onSubmit={submit} className="mypay-rise mx-auto w-full max-w-md rounded-2xl border border-[#E5DFD0] bg-white p-6 sm:p-8 shadow-[0_20px_60px_-30px_rgba(26,31,46,0.45)] space-y-5" data-testid="mypay-login-form">
      <div className="flex items-center gap-3">
        <span className="grid h-11 w-11 place-items-center rounded-xl bg-[#2D5F4F] text-white"><LockKeyhole className="h-5 w-5" /></span>
        <p className="text-sm text-gray-600 leading-snug">{t('loginHint')}</p>
      </div>
      {sites.length > 1 && (
        <div>
          <Label htmlFor="mypay-site">{t('site')}</Label>
          <select id="mypay-site" value={site} onChange={(e) => setSite(e.target.value)} data-testid="mypay-site-select"
            className="h-12 w-full rounded-md border border-input bg-white px-3 text-base">
            {sites.map((s) => <option key={s.site_id} value={s.site_id}>{s.site_name}</option>)}
          </select>
        </div>
      )}
      <div>
        <Label htmlFor="mypay-staff-id">{t('staffId')}</Label>
        <Input id="mypay-staff-id" value={sid} onChange={(e) => setSid(e.target.value.toUpperCase())} autoComplete="off" autoCapitalize="characters"
          className="h-12 text-lg font-mono tracking-wider" placeholder="e.g. 1024" data-testid="mypay-staff-id-input" />
      </div>
      <div>
        <Label htmlFor="mypay-dob">{t('dob')} <span className="font-normal text-gray-400">(DD-MM-YYYY)</span></Label>
        <DobInput id="mypay-dob" value={dob} onChange={setDob} data-testid="mypay-dob-input" />
      </div>
      {error && <p className="rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700" data-testid="mypay-login-error">{error}</p>}
      <Button type="submit" disabled={!ready} className="h-12 w-full rounded-xl bg-[#1A1F2E] text-base hover:bg-[#2D5F4F] transition-colors" data-testid="mypay-login-btn">
        {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : t('view')}
      </Button>
      <p className="flex items-center gap-1.5 text-xs text-gray-500"><ShieldCheck className="h-4 w-4 text-[#2D5F4F]" />{t('privacy')}</p>
    </form>
  );
};

export default LoginCard;
